// Safe sessionStorage wrapper — the primary API token remains in sessionStorage for the
// bearer-token API design. Do not fall back to JS-readable cookies.
// Note: /uploads (static files) is additionally guarded by a server-set HttpOnly,
// Secure (prod), SameSite=Lax cookie set at login — it is read-only file access, so
// SameSite=Lax provides the CSRF protection. See server authController requireUploadAuth.
const safeStorage = {
  getItem(key) {
    try {
      return sessionStorage.getItem(key)
    } catch {
      return null
    }
  },
  setItem(key, value) {
    try {
      sessionStorage.setItem(key, value)
    } catch {}
  },
  removeItem(key) {
    try { sessionStorage.removeItem(key) } catch {}
  }
}

export const authenticate = (response, next) => {
  safeStorage.setItem('token', JSON.stringify(response.data.token))
  safeStorage.setItem('user', JSON.stringify(response.data.user))
  next()
}

export const getToken = () => {
  const raw = safeStorage.getItem('token')
  if (!raw) return false
  try { return JSON.parse(raw) } catch { return false }
}

export const getUser = () => {
  const raw = safeStorage.getItem('user')
  if (!raw) return false
  try { return JSON.parse(raw) } catch { return false }
}

export const logout = (next) => {
  safeStorage.removeItem('token')
  safeStorage.removeItem('user')
  safeStorage.removeItem('pos_name')
  // Best-effort clear of the HttpOnly /uploads access cookie. keepalive lets the
  // request complete even though `next()` usually navigates away immediately.
  try {
    const api = process.env.REACT_APP_API || 'http://localhost:3002/api'
    fetch(`${api}/user/logout`, { method: 'POST', credentials: 'include', keepalive: true }).catch(() => {})
  } catch {}
  next()
}

export const getPosName = () => {
  return safeStorage.getItem('pos_name') || ''
}

export const setPosName = (value) => {
  safeStorage.setItem('pos_name', value)
}

export const getUserId = () => {
  const raw = safeStorage.getItem('user')
  if (!raw) return undefined
  try { return JSON.parse(raw).t_id } catch { return undefined }
}

export const getFullName = () => {
  const raw = safeStorage.getItem('user')
  if (!raw) return undefined
  try { return JSON.parse(raw).t_name } catch { return undefined }
}

// Merge fields into the cached user object (e.g. after editing own profile)
export const updateStoredUser = (patch) => {
  const raw = safeStorage.getItem('user')
  if (!raw) return
  try {
    const user = JSON.parse(raw)
    safeStorage.setItem('user', JSON.stringify({ ...user, ...patch }))
  } catch {}
}